// Hardcoded backend URL to ensure correct Render deployment is used.
// To override, set REACT_APP_BACKEND_URL in your Vercel/local .env file.
const BACKEND_URL = 'https://nexus-ai-backend-jzit.onrender.com';
console.log('--- CONNECTIVITY DIAGNOSTIC ---');
console.log('ACTIVE BACKEND URL:', BACKEND_URL);
console.log('------------------------------');

export async function generateWebsite(description, onUpdate) {
  try {
    console.log('Sending request to:', `${BACKEND_URL}/api/generate-website`);
    const response = await fetch(`${BACKEND_URL}/api/generate-website`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ description }),
    });

    if (!response.ok) {
      console.error('Response not OK:', response.status, response.statusText);
      const text = await response.text();
      console.error('Response body:', text);
      throw new Error('Network response was not ok');
    }

    await handleStreamingResponse(response, onUpdate);
  } catch (error) {
    console.error('Error calling backend API:', error);
    throw new Error('Failed to generate website: ' + error.message);
  }
}

export async function modifyWebsite(modificationDescription, currentHtml, currentCss, onUpdate) {
  try {
    console.log('Sending request to:', `${BACKEND_URL}/api/modify-website`);
    const response = await fetch(`${BACKEND_URL}/api/modify-website`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ modificationDescription, currentHtml, currentCss }),
    });

    if (!response.ok) {
      console.error('Response not OK:', response.status, response.statusText);
      const text = await response.text();
      console.error('Response body:', text);
      throw new Error('Network response was not ok');
    }

    await handleStreamingResponse(response, onUpdate);
  } catch (error) {
    console.error('Error calling backend API:', error);
    throw new Error('Failed to modify website: ' + error.message);
  }
}

async function handleStreamingResponse(response, onUpdate) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split('\n\n');
      // The last part may be incomplete; keep it in the buffer
      buffer = parts.pop() || '';

      for (const part of parts) {
        const lines = part.split('\n');
        for (const line of lines) {
          const trimmedLine = line.trim();
          if (trimmedLine.startsWith('data: ')) {
            const data = trimmedLine.slice(6).trim();
            if (data === '[DONE]') return;
            if (!data) continue;

            try {
              const parsedData = JSON.parse(data);
              if (parsedData.error) {
                console.error('SSE Error from backend:', parsedData.error);
                throw new Error(parsedData.error);
              }
              onUpdate(parsedData);
            } catch (error) {
              // If it's an explicit error from the backend, rethrow it
              if (error.message && !error.name.includes('SyntaxError') && !error.message.includes('JSON')) {
                throw error;
              }
              // Safely ignore intermediate partial chunk syntax errors while streaming
              console.warn('Skipping incomplete stream chunk JSON parse error:', error.message);
            }
          }
        }
      }
    }
  } catch (err) {
    if (err.name === 'AbortError') {
      console.log('Stream aborted by user/browser');
    } else {
      console.error('Stream read error:', err);
      throw err;
    }
  } finally {
    reader.releaseLock();
  }
}